// GENERATED FILE, PLEASE DO NOT EDIT
var PaginationNumbered = 'Circle';
var ShapeSemanticsAll = {
  PaginationNumbered: PaginationNumbered
};

export { PaginationNumbered, ShapeSemanticsAll, ShapeSemanticsAll as default };
